import { useRef } from 'react';

import { Dialog, DialogHandle } from 'components/modal_manager';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNotification } from 'app/notifications';
import { Button } from 'react-bootstrap';
import { useSuperState } from 'hooks';
import { UsersApi } from 'apis';

export const Preferences = props => {

    const [state, setState] = useSuperState({
        loading: false
    });
    const { loading } = state;

    const { formatMessage } = useIntl();
    const { createToast } = useNotification();

    const confirmationDialog = useRef<DialogHandle>(null);

    const resetPreferences = async () => {

        try {

            setState({ loading: true });

            await UsersApi.ResetPreferences();
            createToast(formatMessage({ id: 'preferences_reset_successfully.c098e45a', defaultMessage: 'Preferences reset successfully.' }), 'success');

            setState({ loading: false });

        } catch (e) {

            console.error(e);
            createToast(formatMessage({ id: 'error_resetting_preferences.7d80e2a9', defaultMessage: 'Error resetting preferences.' }), 'danger');
            setState({ loading: false });

        }

    };

    const confirmResetPreferences = () => {

        const dialog = confirmationDialog?.current;
        if (!dialog) return;

        dialog.show({
            actions: [
                dialog.CancelAction(),
                dialog.OKAction({
                    label: formatMessage({ id: 'reset.43ed980c', defaultMessage: 'Reset' }),
                    onClick: resetPreferences,
                    variant: 'danger'
                })
            ],
            body: (
                <p>

                    <FormattedMessage defaultMessage="Are you sure you want to reset your site preferences? This cannot be undone." id="are_you_sure_you_want_to_reset_your_site.bbd3b818" />
                </p>
            ),
            title: formatMessage({ id: 'confirm_reset_site_preferences.bd142700', defaultMessage: 'Confirm reset site preferences' })
        });

    };

    const resetTours = async () => {

        try {

            setState({ loading: true });

            await UsersApi.ResetAllTours();
            createToast(formatMessage({ id: 'tours_reset_successfully.1d5b6fe1', defaultMessage: 'Tours reset successfully.' }), 'success');

            setState({ loading: false });

        } catch (e) {

            console.error(e);
            createToast(formatMessage({ id: 'error_resetting_tours.c49f0142', defaultMessage: 'Error resetting tours.' }), 'danger');
            setState({ loading: false });

        }

    };

    const confirmResetTours = () => {

        const dialog = confirmationDialog?.current;
        if (!dialog) return;

        dialog.show({
            actions: [
                dialog.CancelAction(),
                dialog.OKAction({
                    label: formatMessage({ id: 'reset.43ed980c', defaultMessage: 'Reset' }),
                    onClick: resetTours,
                    variant: 'danger'
                })
            ],
            body: (
                <p>

                    <FormattedMessage defaultMessage="Are you sure you want to reset all on-screen tours? This cannot be undone." id="are_you_sure_you_want_to_reset_all_on_sc.0924d579" />
                </p>
            ),
            title: formatMessage({ id: 'confirm_reset_on_screen_tours.6d84393f', defaultMessage: 'Confirm reset on-screen tours' })
        });

    };

    return (
        <div className={'general'}>
            <div className="d-flex justify-content-between mb-3">
                <h3 className="text-strong">
                    <FormattedMessage defaultMessage="Preferences" id="preferences.2bb53b2b" />
                </h3>
            </div>

            <div className={'d-flex flex-column gap-3'}>
                <div>
                    <div className="text-strong fw-semibold mb-2">
                        <FormattedMessage defaultMessage="Reset Site Preferences" id="reset_site_preferences.2c32a2c7" />
                    </div>
                    <p className="text-muted mb-3">
                        <FormattedMessage defaultMessage="Resetting site preferences will restore all view and filter settings on tables to their default state." id="resetting_site_preferences_will_restore.ef3eae0e" />
                    </p>
                    <Button disabled={loading} onClick={confirmResetPreferences} variant="outline-primary">
                        <FormattedMessage defaultMessage="Reset Preferences" id="reset_preferences.3312b82d" />
                    </Button>
                </div>

                {/* <div>
                    <div className="text-strong fw-semibold mb-2">
                        Reset All On-Screen Tours
                    </div>
                    <p className="text-muted mb-3">
                        Resetting tours will cause all on-screen tours to display again.
                    </p>
                    <Button disabled={loading} onClick={confirmResetTours} variant="outline-primary">
                        Reset Tours
                    </Button>
                </div> */}
            </div>

            <Dialog ref={confirmationDialog} />

        </div>
    );

};